import React from 'react';

import classes from '../Pages/ConfirmationRegistrationMail.module.css'

export default function ConfirmationRegistrationMail(props) {
    return(
        <>
        <div className={classes.ConfirmationContainer}>
            <div className={classes.Confirmation}>
                <div>
                    <h3>WILLKOMMEN</h3>
                </div>
                <div >
                    <i className='icon-confirm icon-speaker'></i>
                </div>
                <p className='body_text'>
                    <div>
                        Ihr Konto wurde erfolgreich erstellt.
                    </div>
                    <div>
                        Bitte bestätigen Sie Ihre E-Mail-Adresse, um Ihr Konto zu aktivieren.
                    </div>
                </p>
            </div>
        </div>
        </>
    )
}